import{supabaseClient}from'../net/supabase-client.js?v=20260801-token-hash-1';

export async function fetchChatMessages(channel,{before=null,limit=60}={}){
  const{data,error}=await supabaseClient.rpc('list_chat_messages',{
    p_channel:channel,p_before:before,p_limit:limit,
  });
  if(error)throw error;
  return Array.isArray(data)?data:[];
}

export async function sendChatMessage(channel,body,attachments,requestId=crypto.randomUUID()){
  const{data,error}=await supabaseClient.rpc('send_chat_message',{
    p_channel:channel,p_body:body,p_attachments:attachments,p_request_id:requestId,
  });
  if(error)throw error;
  return data;
}

export function subscribeToChat(channel,onChange){
  const realtime=supabaseClient.channel(`chat:messages:${channel}:${crypto.randomUUID()}`)
    .on('postgres_changes',{event:'INSERT',schema:'public',table:'chat_messages',filter:`channel=eq.${channel}`},onChange)
    .subscribe();
  return()=>supabaseClient.removeChannel(realtime);
}

export function subscribeToChatPresence({userId,trainerName,onCount}){
  const presence=supabaseClient.channel('chat:presence',{config:{presence:{key:userId}}});
  const update=()=>onCount(Object.values(presence.presenceState()).reduce((sum,entries)=>sum+entries.length,0));
  presence.on('presence',{event:'sync'},update).subscribe(async status=>{
    if(status==='SUBSCRIBED')await presence.track({user_id:userId,trainer_name:trainerName,online_at:new Date().toISOString()});
  });
  return()=>supabaseClient.removeChannel(presence);
}
